import { useState,useEffect } from "react";
import ReactModalLogin from "react-modal-login";
import { supabase } from "../supabase";
import "react-modal-login/dist/react-modal-login.css";
const AuthModal=({modalOpen,handleAuthData})=>
{
const [showModal,setShowModal] = useState(modalOpen)
const [loading,setLoading] = useState(false)
const [error,setError] = useState(null)

const onLogin = async () => {
  const email = document.querySelector("#email").value;
  const password = document.querySelector("#password").value;

  if (!email || !password) {
    setError('טופס לא תקין')
  } else {
    try {
      const { data, error: authError } = await supabase.auth.signInWithPassword({
        email,
        password
      })
      if (authError) throw authError
      const authData = {
        access_token: data.session.access_token,
        user: {
          id: data.user.id,
          username: data.user.email,
          email: data.user.email,
          role: data.user.user_metadata?.role || 'viewer'
        }
      }
      handleAuthData(authData)
      localStorage.setItem('authdata', JSON.stringify(authData))
      setShowModal(false)
    } catch (err) {
      console.log(err)
      setError(err.message || 'Login failed')
    }
  }
};

const onRegister = async() => {
  const username = document.querySelector("#username").value;
  const email = document.querySelector("#email").value;
  const password = document.querySelector("#password").value;

  if (!username || !email || !password) {
    setError('טופס לא תקין')
  } else {
    try {
      const { data, error: authError } = await supabase.auth.signUp({
        email,
        password,
        options: { data: { username } }
      })
      if (authError) throw authError
      const authData = {
        access_token: data.session?.access_token,
        user: {
          id: data.user.id,
          username: username,
          email: data.user.email,
          role: data.user.user_metadata?.role || 'viewer'
        }
      }
      handleAuthData(authData)
      localStorage.setItem('authdata', JSON.stringify(authData))
      setShowModal(false)
    } catch (err) {
      console.log(err)
      setError(err.message || 'Registration failed')
    }
  }
};
useEffect(() => {
setShowModal(modalOpen)
}, [modalOpen])

    return (
      <>
        <ReactModalLogin

        tabs={{loginLabel:'login',registerLabel:null}}
          form={{
            onLogin: onLogin,
            loginBtn: {
              label: "confirm",
            },

            loginInputs: [
              {
                containerClass: "RML-form-group",
                label: "Email",
                type: "email",
                inputClass: "RML-form-control",
                id: "email",
                name: "email",
                placeholder: "email",
              },
              {
                containerClass: "RML-form-group",
                label: "Password",
                type: "password",
                inputClass: "RML-form-control",
                id: "password",
                name: "password",
                placeholder: "password",
              },
            ],

            recoverPasswordInputs: [
              {
                containerClass: "RML-form-group",
                label: "Email",
                type: "email",
                inputClass: "RML-form-control",
                id: "email",
                name: "email",
                placeholder: "email",
              },
            ],
          }}

          initialTab={'login'}
          visible={showModal}
          onCloseModal={()=>setShowModal(false)}
          loading={loading}
          error={error}

          loginError={{
            label: error
          }}

          startLoading={()=>setLoading(true)}
          finishLoading={()=>setLoading(false)}
        />
      </>
    );
  }


export default AuthModal
